export default {
  lang: {
    zhCN: '简体中文',
    enUS: 'English'
  },
  common: {
    home: '首页',
    logout: '退出',
    language: '语言',
    loading: '加载中...',
    noMore: '没有更多了',
    pullToLoadMore: '下拉加载更多',
    cancel: '取消',
    back: '返回',
    user: '用户'
  },
  homeLayout: {
    navHome: '首页',
    navProducts: '产品目录',
    navNewArrivals: '新品区',
    navMyFavorites: '我的收藏',
    login: '登录',
    inquiry: '询价',
    inquiryWithCount: '询价（{count}{cbm}）',
    cartCbmSuffix: ' / CBM: {value}',
    searchKeyword: '关键字',
    searchOemNumber: 'OEM 编号',
    searchPartNumber: '配件编号',
    placeholderKeyword: '搜索关键字',
    placeholderOemNumber: '搜索 OEM 编号',
    placeholderPartNumber: '搜索配件编号',
    productDetailFallback: '商品详情',
    loginFirst: '请先登录',
    floatingCartDetails: '明细',
    favoriteCategory: '收藏类目',
    unfavoriteCategory: '取消收藏',
    favoriteSuccess: '已收藏该类目',
    unfavoriteSuccess: '已取消收藏',
    favoriteFailed: '收藏失败，请重试',
    unfavoriteFailed: '取消收藏失败，请重试',
    favoritesEmptyNav: '暂无收藏类目',
    favoritesSelectCategory: '请选择左侧收藏类目查看商品',
    noYearCategories: '暂无车型年份'
  },
  homePage: {
    addToInquiry: '加入询价',
    loading: '加载中...',
    noMore: '没有更多了',
    pullToLoadMore: '下拉加载更多',
    inquiryList: '询价单',
    productDetails: '产品详情',
    contactSalesTeam: '联系销售团队',
    cancel: '取消',
    generateInquiryList: '生成询价单',
    aboutUs: '关于我们',
    customerService: '客户服务',
    fits: '适配',
    sku: 'SKU',
    fobShanghai: 'FOB 上海：',
    qty: '数量：',
    amount: '金额：',
    wechat: '微信',
    whatsapp: 'WhatsApp',
    rfqTip: '欢迎通过微信或 WhatsApp 分享您的询价需求，我们将尽快为您提供精准报价。',
    footerCompany: '公司介绍',
    footerContact: '联系我们',
    footerCareers: '加入我们',
    footerHelpCenter: '帮助中心',
    footerShipping: '配送说明',
    footerReturns: '退换政策',
    footerFollowUs: '关注我们',
    weibo: '微博',
    tiktok: '抖音/TikTok',
    email: '邮箱',
    footerContactTitle: '联系方式',
    hotline: '热线',
    hours: '服务时间',
    allRightsReserved: '版权所有',
    side: '方向：',
    left: '左',
    right: '右',
    selectSideFirst: '请先选择方向（左或右）'
  },
  productDetail: {
    price: '价格：',
    originalPrice: '原价：',
    productNo: '产品编号',
    fits: '适配车型',
    oem: 'OEM',
    category: '分类',
    stock: '库存',
    unit: '单位',
    spec: '规格',
    defaultSpec: '默认规格',
    side: '方向：',
    left: '左',
    right: '右',
    selectSideFirst: '请先选择方向（左或右）',
    productIdRequired: '缺少商品ID',
    loadFailedSimple: '商品加载失败',
    loadFailedRetry: '商品加载失败，请稍后重试',
    loginToInquiry: '请先登录后再加入询价',
    invalidProductInfo: '商品信息无效',
    addInquirySuccess: '已加入询价单',
    addInquiryFailed: '加入询价失败',
    addInquiryFailedRetry: '加入询价失败，请稍后重试',
    attributes: '属性',
    addToInquiry: '加入询价',
    productDetails: '产品详情',
    noProductDetails: '暂无产品详情',
    loadFailed: '商品加载失败'
  },
  route: {
    landing: '门户首页',
    home: '产品目录',
    productDetail: '商品详情',
    newArrivals: '新品区',
    favorites: '我的收藏'
  },
  tip: {
    loadMenuFailed: '加载菜单失败',
    searchFailedRetry: '搜索失败，请稍后重试',
    productIdNotFound: '商品ID不存在',
    loginBeforeAddToCart: '请先登录后再加入购物车',
    addProductToInquirySuccess: '已将 {name} 加入询价单',
    addInquiryFailed: '加入询价失败',
    addInquiryFailedRetry: '加入询价失败，请稍后重试',
    selectItemsToCheckout: '请选择要询价的商品',
    searchResultTitle: '搜索结果：{keyword}',
    productListTitle: '产品列表',
    generatingConfirmOrder: '正在生成确认单...',
    generateConfirmFailed: '生成确认单失败',
    generateConfirmFailedRetry: '生成确认单失败，请稍后重试',
    invalidOrderInfoRegenerate: '订单信息无效，请重新生成',
    invalidInquiryDataReselect: '询价数据无效，请重新选择商品',
    inquiryGeneratedSuccess: '询价单生成成功',
    orderSubmitFailed: '提交订单失败',
    orderSubmitFailedRetry: '提交订单失败，请稍后重试',
    loginFirst: '请先登录',
    loadProductsFailed: '加载商品失败',
    loadProductsFailedRetry: '加载商品失败，请稍后重试',
    orderIdRequired: '缺少订单ID',
    downloadQuotationFailed: '下载询价单失败',
    downloadQuotationFailedRetry: '下载询价单失败，请稍后重试',
    downloadingQuotation: '正在下载询价单，请稍候...',
    quotationDownloaded: '询价单下载成功',
    verifyFailedLoginAgain: '身份校验失败，请重新登录',
    loginSuccess: '登录成功',
    registerSuccessPleaseLogin: '注册成功，请登录',
    emailCodeSent: '验证码已发送至您的邮箱',
    resetEmailCodeSent: '找回密码验证码已发送至您的邮箱',
    resetPasswordSuccess: '密码重置成功，请登录',
    wechatCopied: '微信号已复制到剪贴板',
    copyFailedManual: '复制失败，请手动复制：{text}',
    loadInquiryListFailed: '加载询价单失败',
    quantityUpdated: '数量已更新',
    quantityUpdateFailed: '更新数量失败',
    quantityUpdateFailedRetry: '更新数量失败，请稍后重试',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    deleteFailedRetry: '删除失败，请稍后重试',
    clearInquiryListConfirm: '确定清空询价单吗？',
    clearInquiryListSuccess: '询价单已清空',
    clearFailed: '清空失败',
    clearFailedRetry: '清空失败，请稍后重试',
    failedGetUserInfo: '获取用户信息失败',
    logoutSuccess: '已退出登录',
    failedLoadAddresses: '加载地址失败',
    addressUpdated: '地址已更新',
    failedUpdateAddress: '更新地址失败',
    failedUpdateAddressRetry: '更新地址失败，请稍后重试',
    addressAdded: '地址已新增',
    failedAddAddress: '新增地址失败',
    failedAddAddressRetry: '新增地址失败，请稍后重试',
    addressDeleted: '地址已删除',
    failedDeleteAddress: '删除地址失败',
    failedDeleteAddressRetry: '删除地址失败，请稍后重试',
    setDefaultSuccess: '已设为默认地址',
    failedSetDefaultAddress: '设置默认地址失败',
    failedSetDefaultRetry: '设置默认地址失败，请稍后重试',
    failedLoadOrders: '加载订单失败',
    failedLoadOrdersRetry: '加载订单失败，请稍后重试',
    failedLoadOrderDetails: '加载订单详情失败',
    failedLoadOrderDetailsRetry: '加载订单详情失败，请稍后重试',
    orderCancelled: '订单已取消',
    failedCancelOrder: '取消订单失败',
    failedCancelOrderRetry: '取消订单失败，请稍后重试',
    orderDeleted: '订单已删除',
    failedDeleteOrder: '删除订单失败',
    failedDeleteOrderRetry: '删除订单失败，请稍后重试',
    orderNumberEmpty: '订单号为空',
    orderNumberCopied: '订单号已复制到剪贴板',
    copyFailedManualNoText: '复制失败，请手动复制',
    invalidOrderInfo: '订单信息无效',
    failedExportQuotation: '导出报价单失败',
    failedExportQuotationRetry: '导出报价单失败，请稍后重试',
    quotationExportedSuccess: '报价单导出成功',
    confirmLogout: '确认退出登录吗？',
    confirmCancelOrder: '确认取消该订单吗？',
    confirmDeleteOrder: '确认删除该订单吗？该操作不可恢复。',
    confirmReceiveOrder: '确认已收货吗？',
    confirmDeleteAddress: '确认删除“{name}”吗？',
    pleaseSelectOrders: '请选择订单',
    noShippableOrders: '所选订单中没有可发货订单',
    deleteSelectedOrders: '确认删除选中的订单吗？',
    paymentUnderDevelopment: '支付功能开发中...',
    confirmReceiptUnderDevelopment: '确认收货功能开发中...',
    exportingQuotation: '正在导出报价单，请稍候...',
    notice: '提示',
    ok: '确定',
    cancel: '取消',
    requestFailed: '请求失败',
    sessionExpiredTitle: '确定登出',
    sessionExpiredMessage: '你已被登出，可以取消继续留在该页面，或者重新登录',
    reLogin: '重新登录'
  },
  validation: {
    validUsernameRequired: '请输入有效用户名',
    emailRequired: '请输入邮箱地址',
    validEmailRequired: '请输入有效邮箱',
    passwordMinLength: '密码长度不能少于3位',
    confirmPasswordRequired: '请确认密码',
    passwordNotMatch: '两次输入的密码不一致',
    validPhoneRequired: '请输入有效手机号',
    emailCodeRequired: '请输入邮箱验证码',
    emailCodeLength: '验证码为6位数字',
    phoneRequired: '请输入手机号',
    recipientNameRequired: '请输入收件人姓名',
    provinceRequired: '请输入省份',
    cityRequired: '请输入城市',
    districtRequired: '请输入区县',
    detailAddressRequired: '请输入详细地址'
  },
  landing: {
    tagline: '专业汽车配件在线询价平台',
    browseProducts: '浏览产品',
    videoTitle: '平台使用介绍',
    videoNotSupported: '您的浏览器不支持视频播放',
    videoPlaceholder: '平台介绍视频即将上线',
    videoPlaceholderHint: '请将视频文件放入 static/video/ 目录',
    aboutTitle: '关于 SKYAUTOMAX',
    aboutDesc: 'SKYAUTOMAX 是面向全球客户的汽车配件在线询价平台。您可以快速搜索 OEM 编号、配件编号或关键字，浏览海量产品目录，一键生成专业询价单，与我们的销售团队高效沟通。',
    feature1: '海量汽车配件产品目录，支持多维度搜索',
    feature2: '在线询价单管理，一键生成报价单',
    feature3: '支持微信 / WhatsApp 与销售团队实时沟通',
    feature4: '移动端与电脑端完美适配，随时随地询价',
    enterWithoutLogin: '暂不登录，先浏览产品',
    newArrivals: '新品上线',
    comingSoon: '即将上线',
    showcaseOnlyHint: '首页专区展示，不进入产品目录列表',
    comingSoonHint: '仅供预览，暂不支持询价',
    tagNew: 'New',
    tagComing: 'Coming Soon'
  },
  auth: {
    login: '登录',
    register: '注册',
    welcomeBack: '欢迎回来',
    createAccount: '创建账号',
    enterAccount: '请输入账号信息',
    createAccountTip: '请填写信息完成注册',
    usernameOrEmail: '用户名或邮箱',
    password: '密码',
    confirmPassword: '确认密码',
    phoneOptional: '手机号（可选）',
    emailCode: '邮箱验证码',
    sendEmailCode: '发送验证码',
    resendEmailCode: '重新发送',
    forgotPassword: '忘记密码？',
    resetPassword: '重置密码',
    resettingPassword: '重置中...',
    newPassword: '新密码',
    resetPasswordTitle: '找回密码',
    resetPasswordTip: '请输入注册邮箱并完成验证',
    backToLogin: '返回登录',
    loggingIn: '登录中...',
    registering: '注册中...',
    sendingCode: '发送中...'
  },
  cart: {
    inquiryTitle: '询价单',
    empty: '询价单为空',
    goShopping: '去逛逛',
    clearInquiry: '清空询价单',
    selectedItems: '已选 {count} 项',
    totalCbm: '总CBM：',
    totalAmount: '总计：',
    checkout: '去询价',
    confirmDeleteItem: '确定要删除该商品吗？',
    expandItems: '展开（共 {count} 件）',
    collapseItems: '收起',
    piecesUnit: '件'
  },
  contact: {
    button: '联系我们',
    dialogTitle: '联系我们',
    email: '邮箱',
    address: '地址',
    whatsapp: 'WhatsApp',
    wechat: '微信',
    copy: '复制',
    wechatQrHint: '扫码添加微信',
    whatsappQrHint: '扫码 WhatsApp 联系'
  },
  profile: {
    title: '个人中心',
    myOrders: '我的订单',
    basicInfo: '基本信息',
    accountEnabled: '账号已启用',
    accountDisabled: '账号已禁用',
    shippingAddress: '收货地址',
    addAddress: '新增地址',
    defaultTag: '默认',
    zip: '邮编',
    edit: '编辑',
    setDefault: '设为默认',
    del: '删除',
    noShippingAddress: '暂无收货地址',
    allOrders: '全部订单',
    pendingPayment: '待付款',
    pendingShipment: '待发货',
    shipped: '已发货',
    completed: '已完成',
    closed: '已关闭',
    orderNo: '订单号',
    orderStatus: '订单状态',
    paymentTime: '支付时间',
    orderType: '订单类型',
    copyOrderNo: '复制订单号',
    inquiryTime: '询价时间',
    exportQuotation: '导出报价单',
    orderTotal: '订单总额：',
    viewDetails: '查看详情',
    pay: '去支付',
    cancelOrder: '取消订单',
    confirmReceipt: '确认收货',
    deleteOrder: '删除订单',
    noOrders: '暂无订单',
    recipient: '收件人',
    phone: '手机号',
    province: '省份',
    city: '城市',
    district: '区县',
    detailAddress: '详细地址',
    postalCode: '邮编',
    setAsDefault: '设为默认地址',
    orderDetails: '订单详情',
    submitOrder: '提交订单',
    payOrder: '支付订单',
    ship: '发货',
    review: '评价',
    recipientInfo: '收货信息',
    shippingAddressLabel: '收货地址',
    productInfo: '商品信息',
    image: '图片',
    product: '商品',
    priceSku: '价格 / SKU',
    attributes: '规格',
    qty: '数量',
    subtotal: '小计',
    paymentInfo: '支付信息',
    subtotalLabel: '商品总价',
    shippingFee: '运费',
    coupon: '优惠券',
    points: '积分',
    promotion: '促销优惠',
    discount: '折扣金额',
    total: '应付总额',
    paid: '实付金额',
    logistics: '物流信息',
    carrier: '物流公司',
    trackingNo: '物流单号',
    fits: '适配',
    oem: 'OEM',
    partNumber: 'Parts Link NO.',
    itemsUnit: '件',
    sku: 'SKU',
    loadOrderFailed: '订单加载失败',
    unpaid: '未支付',
    flashSale: '秒杀订单',
    normalOrder: '普通订单',
    unknown: '未知'
  },
  adminOrder: {
    search: '搜索',
    reset: '重置',
    ok: '确定',
    cancel: '取消',
    filterTitle: '筛选搜索',
    orderNo: '订单编号',
    orderNoPlaceholder: '请输入订单号',
    receiver: '收货人',
    receiverPlaceholder: '姓名 / 手机号',
    submitTime: '提交时间',
    selectDate: '选择日期',
    status: '订单状态',
    all: '全部',
    orderType: '订单类型',
    source: '订单来源',
    orderList: '订单列表',
    id: 'ID',
    user: '用户账号',
    amount: '订单金额',
    payment: '支付方式',
    actions: '操作',
    view: '查看',
    close: '关闭',
    ship: '发货',
    track: '物流',
    delete: '删除',
    batchAction: '批量操作',
    closeOrder: '关闭订单',
    note: '操作备注',
    notePlaceholder: '请输入操作备注',
    noteRequired: '备注不能为空',
    updatedSuccessfully: '更新成功',
    deletedSuccessfully: '删除成功',
    pendingPayment: '待付款',
    pendingShipment: '待发货',
    shipped: '已发货',
    completed: '已完成',
    closed: '已关闭',
    invalid: '无效订单',
    unpaid: '未支付',
    alipay: '支付宝',
    wechat: '微信',
    normal: '普通订单',
    flashSale: '秒杀订单',
    pc: 'PC',
    app: 'APP',
    batchShip: '批量发货',
    batchClose: '批量关闭订单',
    batchDelete: '批量删除订单',
    pleaseSelectOrders: '请选择订单',
    noShippableOrders: '所选订单中没有可发货订单',
    deleteSelectedOrders: '确认删除选中订单吗？',
    notice: '提示'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/zh-CN.js